import { Link, RegisteredRouter, LinkProps } from '@tanstack/react-router';
import styled, { css } from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

import { media } from '../../media';

type CustomLinkProps = LinkProps<RegisteredRouter> & {
  $hovered?: boolean;
  $active?: boolean;
  onClick?: VoidFunction;
};

const StyledTextLink = styled(Link as React.FC<CustomLinkProps>)`
  color: ${color.textBrand};
  text-decoration: none;

  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.6;
        `
      : css`
          &:hover,
          &:active {
            color: ${color.textBrandHovered};
            text-decoration: underline;
          }
        `}

  ${({ $hovered, $active, disabled }) =>
    !disabled &&
    ($hovered || $active) &&
    css`
      @media ${media.sm} {
        color: ${color.textBrandHovered};
        text-decoration: underline;
      }
    `}
`;

export function TextLink(props: CustomLinkProps) {
  return <StyledTextLink {...props} />;
}
